export default __webpack_public_path__ + "static/studionft-1-01435d3d44e38102e81cfe7ea563bfd2.jpg";